/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaChoice/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function TysiaChoice({
  children,
  viewPath = "/DesignSystem/TysiaChoice",
  backgroundColor,
  borderColor,
  borderTopRightRadius,
  borderWidth = 2,
  onClick,
  width = "100%",
  paddingBottom,
  paddingLeft,
  paddingRight,
  paddingTop,
  type,
  hovered,
  selected,
  disabled,
  isSelected
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let dtTysiachoiceBackgroundcolorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoice.backgroundColor.primary.base'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtTysiachoiceBordercolorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoice.borderColor.primary.base'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtTysiachoiceBackgroundcolorPrimaryHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoice.backgroundColor.primary.hovered'
        })
let dtTysiachoiceBordercolorPrimaryHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoice.borderColor.primary.hovered'
        })
let dtTysiachoiceBackgroundcolorPrimarySelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoice.backgroundColor.primary.selected'
        })
let dtTysiachoiceBordercolorPrimarySelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoice.borderColor.primary.selected'
        })
let dtTysiachoiceBackgroundcolorPrimaryDisabled = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoice.backgroundColor.primary.disabled'
        })
let dtTysiachoiceBordercolorPrimaryDisabled = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoice.borderColor.primary.disabled'
        })
let dtTysiachoiceBackgroundcolorSecondaryHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoice.backgroundColor.secondary.hovered'
        })
let dtTysiachoiceBordercolorSecondaryHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoice.borderColor.secondary.hovered'
        })
let dtTysiachoiceBackgroundcolorSecondarySelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoice.backgroundColor.secondary.selected'
        })
let dtTysiachoiceBordercolorSecondarySelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoice.borderColor.secondary.selected'
        })
let dtTysiachoiceBackgroundcolorSecondaryDisabled = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoice.backgroundColor.secondary.disabled'
        })
let dtTysiachoiceBordercolorSecondaryDisabled = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoice.borderColor.secondary.disabled'
        })
let dtTysiachoiceBackgroundcolorSecondaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoice.backgroundColor.secondary.base'
        })
let dtTysiachoiceBordercolorSecondaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoice.borderColor.secondary.base'
        })
let dtTysiachoiceBackgroundcolorDangerHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoice.backgroundColor.danger.hovered'
        })
let dtTysiachoiceBordercolorDangerHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoice.borderColor.danger.hovered'
        })
let dtTysiachoiceBackgroundcolorDangerSelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoice.backgroundColor.danger.selected'
        })
let dtTysiachoiceBordercolorDangerSelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoice.borderColor.danger.selected'
        })
let dtTysiachoiceBackgroundcolorDangerDisabled = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoice.backgroundColor.danger.disabled'
        })
let dtTysiachoiceBordercolorDangerDisabled = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoice.borderColor.danger.disabled'
        })
let dtTysiachoiceBackgroundcolorDangerBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoice.backgroundColor.danger.base'
        })
let dtTysiachoiceBordercolorDangerBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoice.borderColor.danger.base'
        })
let dtTysiachoiceBackgroundcolorBrandHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoice.backgroundColor.brand.hovered'
        })
let dtTysiachoiceBordercolorBrandHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoice.borderColor.brand.hovered'
        })
let dtTysiachoiceBackgroundcolorBrandSelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoice.backgroundColor.brand.selected'
        })
let dtTysiachoiceBordercolorBrandSelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoice.borderColor.brand.selected'
        })
let dtTysiachoiceBackgroundcolorBrandDisabled = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoice.backgroundColor.brand.disabled'
        })
let dtTysiachoiceBordercolorBrandDisabled = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoice.borderColor.brand.disabled'
        })
let dtTysiachoiceBackgroundcolorBrandBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoice.backgroundColor.brand.base'
        })
let dtTysiachoiceBordercolorBrandBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoice.borderColor.brand.base'
        })
let backgroundColorOrdtTysiachoiceBackgroundcolorPrimaryBase = backgroundColor ?? dtTysiachoiceBackgroundcolorPrimaryBase
let borderColorOrdtTysiachoiceBordercolorPrimaryBase = borderColor ?? dtTysiachoiceBordercolorPrimaryBase
let borderColorOrdtTysiachoiceBordercolorSecondaryBase = borderColor ?? dtTysiachoiceBordercolorSecondaryBase
let borderColorOrdtTysiachoiceBordercolorSecondarySelected = borderColor ?? dtTysiachoiceBordercolorSecondarySelected
let borderColorOrdtTysiachoiceBordercolorSecondaryHovered = borderColor ?? dtTysiachoiceBordercolorSecondaryHovered
let borderTopRightRadiusOrdtSpaceXs = borderTopRightRadius ?? dtSpaceXs
let paddingBottomOrdtSpaceS = paddingBottom ?? dtSpaceS
let paddingLeftOrdtSpaceS = paddingLeft ?? dtSpaceS
let paddingRightOrdtSpaceS = paddingRight ?? dtSpaceS
let paddingTopOrdtSpaceS = paddingTop ?? dtSpaceS
  return (<React.Fragment
>
<button
  data-testid="TysiaChoice.Vertical"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--bblr-2-dJMvm': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-3-dJMvm': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btlr-5-dJMvm': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-6-dJMvm': typeof borderTopRightRadiusOrdtSpaceXs === 'number' ? `${borderTopRightRadiusOrdtSpaceXs}px` : borderTopRightRadiusOrdtSpaceXs,'--bw-7-dJMvm': typeof borderWidth === 'number' ? `${borderWidth}px` : borderWidth,'--w-8-dJMvm': typeof width === 'number' ? `${width}px` : width,'--pb-9-dJMvm': typeof paddingBottomOrdtSpaceS === 'number' ? `${paddingBottomOrdtSpaceS}px` : paddingBottomOrdtSpaceS,'--pl-10-dJMvm': typeof paddingLeftOrdtSpaceS === 'number' ? `${paddingLeftOrdtSpaceS}px` : paddingLeftOrdtSpaceS,'--pr-11-dJMvm': typeof paddingRightOrdtSpaceS === 'number' ? `${paddingRightOrdtSpaceS}px` : paddingRightOrdtSpaceS,'--pt-12-dJMvm': typeof paddingTopOrdtSpaceS === 'number' ? `${paddingTopOrdtSpaceS}px` : paddingTopOrdtSpaceS,'--bc-1-dJMvm': type === "primary" && hovered ? dtTysiachoiceBackgroundcolorPrimaryHovered : type === "primary" && selected ? dtTysiachoiceBackgroundcolorPrimarySelected : type === "primary" && disabled ? dtTysiachoiceBackgroundcolorPrimaryDisabled : type === "primary" ? dtTysiachoiceBackgroundcolorPrimaryBase : type === "secondary" && hovered ? dtTysiachoiceBackgroundcolorSecondaryHovered : type === "secondary" && selected ? dtTysiachoiceBackgroundcolorSecondarySelected : type === "secondary" && disabled ? dtTysiachoiceBackgroundcolorSecondaryDisabled : type === "secondary" ? dtTysiachoiceBackgroundcolorSecondaryBase : type === "danger" && hovered ? dtTysiachoiceBackgroundcolorDangerHovered : type === "danger" && selected ? dtTysiachoiceBackgroundcolorDangerSelected : type === "danger" && disabled ? dtTysiachoiceBackgroundcolorDangerDisabled : type === "danger" ? dtTysiachoiceBackgroundcolorDangerBase : type === "brand" && hovered ? dtTysiachoiceBackgroundcolorBrandHovered : type === "brand" && selected ? dtTysiachoiceBackgroundcolorBrandSelected : type === "brand" && disabled ? dtTysiachoiceBackgroundcolorBrandDisabled : type === "brand" ? dtTysiachoiceBackgroundcolorBrandBase : hovered ? dtTysiachoiceBackgroundcolorPrimaryHovered : selected ? dtTysiachoiceBackgroundcolorPrimarySelected : disabled ? dtTysiachoiceBackgroundcolorPrimaryDisabled : backgroundColorOrdtTysiachoiceBackgroundcolorPrimaryBase,'--bc-4-dJMvm': type === "primary" && hovered ? dtTysiachoiceBordercolorPrimaryHovered : type === "primary" && selected ? dtTysiachoiceBordercolorPrimarySelected : type === "primary" && disabled ? dtTysiachoiceBordercolorPrimaryDisabled : type === "primary" ? dtTysiachoiceBordercolorPrimaryBase : type === "secondary" && hovered ? borderColorOrdtTysiachoiceBordercolorSecondaryHovered : type === "secondary" && selected ? borderColorOrdtTysiachoiceBordercolorSecondarySelected : type === "secondary" && disabled ? dtTysiachoiceBordercolorSecondaryDisabled : type === "secondary" ? borderColorOrdtTysiachoiceBordercolorSecondaryBase : type === "danger" && hovered ? dtTysiachoiceBordercolorDangerHovered : type === "danger" && selected ? dtTysiachoiceBordercolorDangerSelected : type === "danger" && disabled ? dtTysiachoiceBordercolorDangerDisabled : type === "danger" ? dtTysiachoiceBordercolorDangerBase : type === "brand" && hovered ? dtTysiachoiceBordercolorBrandHovered : type === "brand" && selected ? dtTysiachoiceBordercolorBrandSelected : type === "brand" && disabled ? dtTysiachoiceBordercolorBrandDisabled : type === "brand" ? dtTysiachoiceBordercolorBrandBase : hovered ? dtTysiachoiceBordercolorPrimaryHovered : selected ? dtTysiachoiceBordercolorPrimaryHovered : disabled ? dtTysiachoiceBordercolorPrimaryDisabled : borderColorOrdtTysiachoiceBordercolorPrimaryBase}}
 className={`views-block ${styles.Vertical}`}
>
<Children
  viewPath={`${viewPath}/Children`}
 type={type}
 hovered={hovered}
 selected={selected}
 disabled={disabled}
 isSelected={isSelected} isHovered={isHovered} isSelectedHovered={isSelectedHovered}
>
{children}
</Children>
</button>
</React.Fragment>)
}